import React, { useRef } from 'react';
import logoSrc from '../img/logo.png';
import './Thirdpartyservices.css';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.


function FinancialServices() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">secure, thriving solutions</h1>
            <p className="banner-description">
              Drive your financial growth with Shigjeta’s expert services. We offer personalized strategies for financial planning, budgeting, and investment management.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>


          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Third Party Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* Financial Planning Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Financial Planning</strong></h2>
            <p>
              We offer tailored financial planning services to guide your long-term financial goals. Whether it’s retirement or savings planning, we provide comprehensive solutions.
            </p>
            <ul>
              <li><strong>Retirement Planning:</strong> Secure your financial future with effective strategies.</li>
              <li><strong>Tax Strategies:</strong> Minimize tax liabilities through expert advice.</li>
              <li><strong>Budgeting:</strong> Create a budget that helps you achieve your financial goals.</li>
              <li><strong>Investment Advice:</strong> Maximize returns with smart investment strategies.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts3.1.png" alt="Financial Planning" />
          </div>
        </div>

        {/* Customized Solutions Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Customized Financial Solutions</strong></h2>
            <p>
              Tailor your financial strategy to fit your unique needs. Our solutions are designed to provide flexibility and growth across different financial markets.
            </p>
            <ul>
              <li><strong>Portfolio Management:</strong> Diversify and manage your investments.</li>
              <li><strong>Financial Tools:</strong> Access personalized financial management tools.</li>
              <li><strong>Insurance Solutions:</strong> Protect your assets with the right insurance policies.</li>
              <li><strong>Wealth Management:</strong> Build and preserve wealth for future generations.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ts3.2.png" alt="Customized Financial Solutions" />
          </div>
        </div>

        {/* Financial Success Stories Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Financial Success Stories</strong></h2>
            <p>
              Learn how our clients have successfully achieved their financial goals with Shigjeta’s expert financial guidance and strategies.
            </p>
            <a href='/blog' className="cta-button">Read Our Financial Success Stories</a>
          </div>
          <div className="about-image">
            <img src="/img/ts3.3.png" alt="Financial Success" />
          </div>
        </div>
      </section>
       
  <ContactForm ref={contactFormRef} />
    </>
  );
}

export default FinancialServices;
